import React from "react";
import ProfilePic from "../assets/passport.jpg";
import { animate, motion } from "framer-motion";
import { animateSection } from "../utils/animateSection";

function About() {
  return (
    <section
      id="about"
      className="py-[20px] sm:pt-[30px] sm:pb-[100px] max-w-[900px]  text-white/25 flex flex-col justify-center mx-auto font-sfMonoRegular overflow-x-hidden"
    >
      <div className="about-heading w-fit flex flex-row  mt-[10px] mb-[40px] ">
        <div className="text-theme-green flex items-center text-[15px] sm:text-[20px]">
          01.{" "}
        </div>
        <h1 className="text-theme-gray-light min-w-fit ml-[10px] text-[26px] sm:text-[32px]  flex justify-center items-center font-calibreSemiBold fontFix">
          About Me{" "}
        </h1>
      </div>
      <div className="flex flex-col md:flex-row align-middle min-h-full text-[20px] font-calibreRegular text-theme-gray-deep font-medium ">
        <div className="">
          <p className="mb-4">
            Hi, I’m Pranshu Jain — a developer, problem solver, and lifelong
            learner. My journey in tech began in 2020 with full-stack web
            development, inspired by Google Assistant. What started as curiosity
            soon grew into a passion for building meaningful, functional
            solutions. Over time, I gravitated toward Machine Learning, AI, and
            Deep Networks, where I found the thrill of teaching machines to
            think and create. I’m now pursuing an{" "}
            <span className="text-theme-green"> M.Tech in CSE (AI & Data Analytics) </span>, honing my skills
            to tackle challenges at the intersection of intelligence and
            innovation. 
            <br></br>
            I’ve had the privilege of working on diverse fronts —
            from contributing to the Sunbird ED project with government
            organizations, to open source contributions, research internships,
            technical book reviewing, a national fellowship, and even winning
            hackathons. These experiences showcase my versatility and reflect my
            drive to keep exploring, learning, and pushing boundaries. At my
            core, I’m guided by a simple goal: to explore emerging technologies
            and create solutions that don’t just work — but truly make a
            difference.
          </p>
          <p className="mb-4">
            Here are a few technologies I’ve been working with recently:
          </p>
          <div className="recent-skills">
            <div className="recent-skills-skill relative mb-[10px] pl-[20px] font-sfMonoRegular text-[14px]">
              AI Agents{" "}
            </div>
            <div className="recent-skills-skill relative mb-[10px] pl-[20px] font-sfMonoRegular text-[14px]">
              NLP
            </div>
            <div className="recent-skills-skill relative mb-[10px] pl-[20px] font-sfMonoRegular text-[14px]">
              Responsible AI
            </div>
            <div className="recent-skills-skill relative mb-[10px] pl-[20px] font-sfMonoRegular text-[14px]">
              MLops
            </div>
          </div>
        </div>
        <div className="mx-auto mt-16 md:mt-0 ">
          <div className="md:ml-[55px] wrap-image w-[200px] md:w-[250px] lg:w-[300px]">
            <img src={ProfilePic} alt="profile pic" className="" />
          </div>
        </div>
      </div>
    </section>
  );
}

function animatedSection() {
  return animateSection(About);
}

export default animatedSection;
